import { CUEEENT_ARTICLE_CONTENT } from '@/constant/const_acticle';
import { Iarticle } from '@/interface/articleInterface';


export function updateArticleContent(value: Iarticle) {
  return {
    type: CUEEENT_ARTICLE_CONTENT,
    value
  }
}